import { render, staticRenderFns } from "./MemberAdminList.vue?vue&type=template&id=c813aa24"
import script from "./MemberAdminList.vue?vue&type=script&lang=js"
export * from "./MemberAdminList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/memberadministrator.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports